import React, {useEffect, useState} from 'react';
import styles from './SegmentedControl.module.css';

type SegmentedControlProps = {
  options: string[];
  selectedOption: string;
  selectedGradientColors?: string[];
  selectedGradientLocations?: number[];
};

const SegmentedControl: React.FC<SegmentedControlProps> = React.memo(
  ({options, selectedOption, selectedGradientColors, selectedGradientLocations}) => {
    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {
      setSelectedIndex(options.indexOf(selectedOption));
    }, [options, selectedOption]);

    const gradientColors = selectedGradientColors ?? ['#FF4A8B', '#FF3963', '#721CFF'];
    const gradientLocations = selectedGradientLocations ?? [0.05, 0.35, 1];

    // Create CSS gradient string
    const gradientStops = gradientColors.map((color, idx) => `${color} ${gradientLocations[idx] * 100}%`).join(', ');
    const gradientStyle = `linear-gradient(180deg, ${gradientStops})`;

    // Calculate position as percentage
    const leftPosition = `${(selectedIndex / options.length) * 100}%`;
    const segmentWidth = `${100 / options.length}%`;

    console.log('leftPosition', leftPosition);
    console.log('segmentWidth', segmentWidth);
    console.log('selectedIndex', selectedIndex);
    console.log('options', options);
    return (
      <div className={styles.container}>
        <div
          className={styles.activeBox}
          style={{
            width: segmentWidth,
            left: leftPosition,
            background: gradientStyle,
          }}
        />
        {options.map((option, index) => {
          return (
            <div
              key={option}
              className={styles.labelContainer}
              style={{
                width: segmentWidth,
                borderLeftWidth: index === 0 ? 0 : 1,
              }}
            >
              <span className={`${styles.label} ${index === selectedIndex ? styles.labelSelected : ''}`}>{option}</span>
            </div>
          );
        })}
      </div>
    );
  },
);

export {SegmentedControl};
